<ng-container *ngIf="formPlycaGroup">
  <div *ngIf="editable" class="p-inputgroup wrap-chips" [formGroup]="formPlycaGroup"
    [ngClass]="(editable) ? 'EDITABLE' : 'NOEDITABLE'">
    <p-chips [ngModel]="this.model.dto.documents" class="plForm-element"
      [ngClass]="(editable) ? 'EDITABLE' : 'NOEDITABLE'" (onAdd)="onAddDocument($event)"
      (onRemove)="onRemoveDocument($event)" (keydown)="cancelKeyPressed($event)" [allowDuplicate]="false"
      formControlName="documents" [disabled]="(editable) ? false : true" inputId="commdocsid">
      <ng-template let-doc pTemplate="item">
        <a (click)="onDocumentClick(doc)" title="Pruebas">
          <span *ngIf="doc.document?.name"><i class="fas fa-paperclip"></i> {{doc.document?.name}}</span>
          <span *ngIf="!doc.document?.name"><i class="fas fa-paperclip"></i>
            {{doc.document?.entity?.documentClass?.name}}</span>
        </a>
      </ng-template>
    </p-chips>
    <button class="btn btn-outline-secondary integrado-multi" [ngClass]="(editable) ? 'EDITABLE' : 'NOEDITABLE'"
      aria-expanded="false" appNoDblClick pTooltip="{{ 'General.search.text' | translate}}" tooltipPosition="top"
      (click)="searchDocuments()" [attr.disabled]="(editable) ? undefined : 'disabled'" id="docSearchBtn" type="button">
      <i class="fas fa-search" aria-hidden="true"></i>
    </button>
  </div>
  <div class="col-12 p-0" *ngIf="!editable">
    <ng-container *ngFor="let doc of this.model.dto.documents">
      <span (click)="onDocumentClick(doc)">
        <a class="btn btn-filter btn-xs m-xs"><span *ngIf="doc.document?.name"><i class="fas fa-paperclip"></i>
            {{doc.document?.name}}</span>
          <span *ngIf="!doc.document?.name"><i class="fas fa-paperclip"></i>
            {{doc.document?.entity?.documentClass?.name}}</span>
        </a>
      </span>
    </ng-container>
    <ng-container *ngIf="!this.model.dto.documents || this.model.dto.documents.length == 0">
      <input type="text" pInputText class="plForm-element NOEDITABLE" [attr.disabled]="'disabled'" />
    </ng-container>
  </div>
</ng-container>